import { useState, useCallback } from 'react';

interface UseAuthModalReturn {
  isAuthModalOpen: boolean;
  isProfileSelectionOpen: boolean;
  authContext: string;
  openAuthModal: (context?: string) => void;
  closeAuthModal: () => void;
  openProfileSelection: () => void;
  closeProfileSelection: () => void;
  transitionToProfileSelection: () => void;
}

export function useAuthModal(): UseAuthModalReturn {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isProfileSelectionOpen, setIsProfileSelectionOpen] = useState(false);
  const [authContext, setAuthContext] = useState('');

  const openAuthModal = useCallback((context?: string) => {
    setAuthContext(context || '');
    setIsAuthModalOpen(true);
  }, []);

  const closeAuthModal = useCallback(() => {
    setIsAuthModalOpen(false);
    setAuthContext('');
  }, []);

  const openProfileSelection = useCallback(() => {
    setIsProfileSelectionOpen(true);
  }, []);

  const closeProfileSelection = useCallback(() => {
    setIsProfileSelectionOpen(false);
  }, []);

  const transitionToProfileSelection = useCallback(() => {
    setIsAuthModalOpen(false);
    setIsProfileSelectionOpen(true);
  }, []);

  return {
    isAuthModalOpen,
    isProfileSelectionOpen,
    authContext,
    openAuthModal,
    closeAuthModal,
    openProfileSelection,
    closeProfileSelection,
    transitionToProfileSelection
  };
}